import React from "react";

const DashboardLoader = () => (
  <div className="widgetGrid">
    {Array.from({ length: 6 }).map((_, i) => (
      <div key={i} className="widgetCard">
        <span className="linear-background widgetSkeletonTitle" />
        <span className="linear-background widgetSkeletonValue" />
        <span className="linear-background widgetSkeletonTrend" />
      </div>
    ))}
  </div>
);

export default DashboardLoader;
